import React, {
    useState, useContext
} from 'react';
import { Button, Icon } from '@ferris/react';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

// Import Swiper styles
// eslint-disable-next-line import/no-unresolved
import { TrackingContext } from '@vrbo/react-event-tracking';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { createInteractionEvent } from '../../utils/EventProviders/EgClickstreamUtil';
// import RIGHT_ARROW from '../../assets/images/right-arrow.png';
// import LEFT_ARROW from '../../assets/images/left-arrow.png';

const Slider = (props) => {
    const {
        slides,
        details,
        addZero
    } = props;

    const [swiperRef, setSwiperRef] = useState(null);
    const [activeIndex, setActiveIndex] = useState(1);
    const { trigger } = useContext(TrackingContext);

    const nextSlide = () => {
        swiperRef.slideNext();
        trigger('interaction', createInteractionEvent('next_button.selected', 'Property Onboarding', `slider-${details}`, '1.4.0'));
    };

    const previousSlide = () => {
        swiperRef.slidePrev();
        trigger('interaction', createInteractionEvent('previous_button.selected', 'Property Onboarding', `slider-${details}`));
    };
    const onSlideChange = () => {
        trigger('interaction', createInteractionEvent('slide_change.succeeded', 'Property Onboarding', `slider-${details}`));
        setActiveIndex(swiperRef.snapIndex + 1);
    };

    const lastFocused = activeIndex === swiperRef?.snapGrid?.length;
    return (
        <div
            className={cn('slider-container')}
        >
            <Swiper
                onSwiper={setSwiperRef}
                centerInsufficientSlides
                slidesPerView="auto"
                spaceBetween={28}
                className={cn('ulx-slider',
                    { 'last-slide-focus': lastFocused },
                    { 'first-slide-focus': activeIndex === 1 })}
                onSlideChange={onSlideChange}
            >
                {
                    slides.map(({ headline, description, image }) => (
                        <SwiperSlide>
                            <div className={cn('slider-slide')}>
                                <img src={image.url} alt={image.alt} />
                                <div className={cn('slider-text')}>
                                    <h3>{headline}</h3>
                                    <p>{description}</p>
                                </div>
                            </div>
                        </SwiperSlide>

                    ))
                }
            </Swiper>
            <div className={cn('slider-controller')}>
                <Button
                    htmlButtonType="button"
                    title="Back"
                    type="round"
                    variant="round-raised"
                    classes={cn('prev-slider')}
                    id={`prev-slider-${details}`}
                    onClick={previousSlide}
                >
                    <Icon name="arrow-back-ios" />
                </Button>
                <Button
                    htmlButtonType="button"
                    title="Forward"
                    type="round"
                    variant="round-raised"
                    classes={cn('next-slider')}
                    id={`next-slider-${details}`}
                    onClick={nextSlide}
                >
                    <Icon name="arrow-forward-ios" />
                </Button>
                {swiperRef && (
                    <span className={cn('slider-progress')}>
                        <b>
                            {(addZero && activeIndex < 10) && '0'}
                            {activeIndex}
                        </b>
                        /
                        {(addZero && swiperRef.snapGrid.length < 10) && '0'}
                        {swiperRef.snapGrid.length}
                    </span>
                )}
            </div>
        </div>
    );
};

Slider.propTypes = {
    details: PropTypes.string.isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape({
        headline: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        image: PropTypes.shape({
            url: PropTypes.string.isRequired,
            alt: PropTypes.string
        }).isRequired
    })).isRequired,
    addZero: PropTypes.bool.isRequired
};

export default Slider;
